import { auth, firebaseAuth, googleProvider, facebookProvider, appleProvider } from './config';

const firebaseAuthService = {
  /**
   * Authenticate via email and password.
   *
   * @param {string} email Email Address.
   * @param {string} password Password.
   * @returns {Promise}
   */
  signupWithEmail: (email, password) => auth.createUserWithEmailAndPassword(email, password),
  loginWithEmail: (email, password) => auth.signInWithEmailAndPassword(email, password),
  logout: () => auth.signOut(),
  loginWithGoogle: () => auth.signInWithPopup(googleProvider),
  loginWithFacebook: () => auth.signInWithPopup(facebookProvider),
  loginWithApple: () => auth.signInWithPopup(appleProvider),
};

/**
 * Send password reset email.
 *
 * @param {string} email Email Address.
 * @returns {Promise}
 */
export const sendPasswordResetEmail = email => {
  return auth.sendPasswordResetEmail(email);
};

/**
 * Get Current user.
 *
 * @returns {Object}
 */
export const getCurrentUser = () => auth.currentUser;

/**
 * Reauthenticate via email and password.
 *
 * @param {string} email Email Address.
 * @param {string} password Password.
 * @returns {Promise}
 */
export const reauthenticateWithEmail = (email, password) => {
  const user = auth.currentUser;

  const credentials = firebaseAuth.EmailAuthProvider.credential(email, password);

  return user.reauthenticateWithCredential(credentials);
};

export default firebaseAuthService;
